import defaultTheme from './defaultTheme';
const harborFreightTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0058AC', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0058AC', background: '#0058AC' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0058AC' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0058AC', border: '#0058AC', background: '#0058AC' }), field: {
        focus: '#0058AC',
        label: '#0058AC',
        icon: '#0058AC',
    } });
export default harborFreightTheme;
